import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Subscription } from 'rxjs';
import { ApiErrorFactory } from '../../core/api-errors';
import { CacheService } from '../../core/cache';
import { ConfirmationDialog } from '../dialog';
import { SpeedScoreService } from '../home';

@Component({
  selector: 'app-purge-cache-card',
  templateUrl: './purge-cache-card.component.html',
  styleUrls: ['./purge-cache-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PurgeCacheComponent implements OnDestroy {
  loading = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private cacheService: CacheService,
    private apiErrorFactory: ApiErrorFactory,
    private speedScoreService: SpeedScoreService,
    private alertService: SnackbarService,
    private translateService: TranslateService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  showDialog(): void {
    this.loading = true;
    this.subscriptions.push(
      this.dialog
        .open(ConfirmationDialog, {
          data: {
            content: 'PAGES.OVERVIEW.FLUSH_CACHE_MODAL.CONFIRMATION.DESCRIPTION',
            action: 'PAGES.OVERVIEW.FLUSH_CACHE_MODAL.BUTTONS.FLUSH',
          },
          disableClose: false,
          hasBackdrop: true,
        })
        .afterClosed()
        .subscribe((shouldPurge: boolean) => {
          if (shouldPurge) {
            this.analyticsService.trackEvent('home-page:purge-cache', 'purge-cache', 'clicked');
            this.cacheService.flushCache().subscribe(
              () => (this.loading = false),
              (err) => this.handleError(err),
            );
            // if a site cache is purged, maybe the user performed some performance changes, so we clear the
            // page speed results from the stats API service
            this.speedScoreService.clear_cache();
          } else {
            this.loading = false;
          }
        }),
    );
  }

  handleError(errorResponse: HttpErrorResponse): void {
    const parsedError = this.apiErrorFactory.parseErrorResponse(errorResponse);
    this.alertService.openErrorSnack(
      parsedError.getUserMessage(),
      this.translateService.instant('ALERTS.GENERAL.DISMISS'),
    );
    this.loading = false;
  }

  // TODO: WP-860 - this feature was disabled, but leaving the code here in case we want to refine it in the future
  // toggleVal(checked: boolean): void {
  //     this.loading = true;
  //     this.subscriptions.push(
  //         this.cacheService.setForceCache(checked).subscribe(
  //             () => {
  //                 this.loading = false;
  //             },
  //             (err) => this.handleError(err),
  //         ),
  //     );
  // }
}
